import { PauseCircleFilled, PlayCircleFilled } from '@ant-design/icons';
import { Button } from 'antd';
import React from 'react';
import { frameToRelativeSeconds } from 'utils/media-time';
interface Props {
    audioPlayingIdx: number;
    audioBlobURL: string;
    audio: any;
    idx: number;
    audiolisteners: any;
    setAudioPlayingIdx: (idx: number) => void;
    playAudio: (idx: number) => void;
    state: any;
    frameRate?: number;
    frameSpeed?: number;
    startFrame?: number;

}
function AudioPlayButton(props: Props): JSX.Element {
    const {audioPlayingIdx,
        audioBlobURL, audio, idx, audiolisteners,
        setAudioPlayingIdx, startFrame = 0, state, frameRate, frameSpeed, playAudio} = props;
    const effectiveFrameRate = frameRate ?? frameSpeed ?? 15;
    return <>
    <audio ref={(el) => {
        if (el) {
            audio.current[idx] = el;
            audiolisteners.current[idx] = () => {
                if (
                    audio.current[idx].currentTime >=
                    frameToRelativeSeconds(state.audio_selected_segments[0].end, startFrame, effectiveFrameRate)
                ) {
                    audio.current[idx].pause();
                    if (audioPlayingIdx !== -1) {
                        setAudioPlayingIdx(-1);
                    }
                }
            }
            audio.current[idx].addEventListener('timeupdate', audiolisteners.current[idx]);
        }
        else {
            if (audio.current[idx]) {
                audio.current[idx].removeEventListener('timeupdate', audiolisteners.current[idx]);
            }
        }
    }} src={audioBlobURL}></audio>
    <Button  style={{fontSize: '64px', height: '150px'}} onClick={
        () => {
            playAudio(idx);
        }
    }>{audioPlayingIdx !== idx ? <PlayCircleFilled /> : <PauseCircleFilled />}</Button>
    </>
}

export default AudioPlayButton;